var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isKeep)?_c('keep-alive',[_c('a-config-provider',{attrs:{"locale":_vm.zh_CN}},[_c('router-view')],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }